import React from 'react';
import {Link} from 'react-router-dom';

import './Header.css';
import Logo from '../../assets/logo2.png';
import UserProfileHeader from '../Users/UserProfileHeader';

const Header = (props) => {
    return (
        <div className="Header">
            <header className="main-header">
                <Link to="/" className="logo">
                    <span className="logo-mini"><b>F</b></span>
                    <span className="logo-lg">
                        <img src={Logo} alt="FoodZaps"/>
                    </span>
                </Link>
                <nav className="navbar navbar-static-top">
                    <a onClick={props.openSidebar} className="sidebar-toggle">
                        <span className="sr-only">Toggle navigation</span>
                    </a>
                    <div className="navbar-custom-menu">
                        <ul className="nav navbar-nav">
                            <UserProfileHeader></UserProfileHeader>
                        </ul>
                    </div>
                </nav>
            </header>
        </div>
    )
}

export default Header;